import "./env";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import ExcalidrawApp from "./App";

import "../excalidraw-app/sentry";
window.__EXCALIDRAW_SHA__ = window._env_.VITE_APP_GIT_SHA;
const rootElement = document.getElementById("root")!;
const root = createRoot(rootElement);

// NOTE: no lookbehind-regex browser gate here on purpose — excalidraw's
// text wrapping already falls back to lookbehind-free regexes on older
// Safari (see packages/excalidraw/element/textWrapping.ts
// getLineBreakRegex try/catch), the same reason excalidraw.com works on
// e.g. a 2014 MacBook Air. Runtime-method gaps (Array.at, Object.hasOwn)
// are covered by packages/excalidraw/polyfill.ts.

// The PWA service worker is intentionally NOT registered: its "autoUpdate"
// mode calls location.reload() inside the lesson iframe whenever a deploy
// ships, killing the board mid-lesson (and the in-iframe reload then trips
// the self-embedding guard). The whiteboard only runs embedded in a live
// call — offline support is useless here. Clients that installed the SW
// from older builds get it removed; sw.js itself is still built so those
// old workers can fetch one last update instead of serving stale assets
// forever.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) => registrations.forEach((r) => r.unregister()))
    .catch(() => undefined);
}
root.render(
  <StrictMode>
    <ExcalidrawApp />
  </StrictMode>,
);
